import { defineStore } from "pinia";

export const useWebinarStore = defineStore("webinar", {
  state: () => ({
    pictureBroadCast: {
      19: { // Webinar 19
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
      },
      17: { // Webinar 17
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
        28: { url: '28.jpg', title: '28', type: 'picture' },
        29: { url: '29.jpg', title: '29', type: 'picture' },
        30: { url: '30.jpg', title: '30', type: 'picture' },
        31: { url: '31.jpg', title: '31', type: 'picture' },
        32: { url: '32.jpg', title: '32', type: 'picture' },
        33: { url: '33.jpg', title: '33', type: 'picture' },
        34: { url: '34.jpg', title: '34', type: 'picture' },
        35: { url: '35.jpg', title: '35', type: 'picture' },
        36: { url: '36.jpg', title: '36', type: 'picture' },
        37: { url: '37.jpg', title: '37', type: 'picture' },
        38: { url: '38.jpg', title: '38', type: 'picture' },
        39: { url: '39.jpg', title: '39', type: 'picture' },
        40: { url: '40.jpg', title: '40', type: 'picture' },
        41: { url: '41.jpg', title: '41', type: 'picture' },
        42: { url: '42.jpg', title: '42', type: 'picture' },
        43: { url: '43.jpg', title: '43', type: 'picture' },
        44: { url: '44.jpg', title: '44', type: 'picture' },
        45: { url: '45.jpg', title: '45', type: 'picture' },
        46: { url: '46.jpg', title: '46', type: 'picture' },
        47: { url: '47.jpg', title: '47', type: 'picture' },
        48: { url: '48.jpg', title: '48', type: 'picture' },
      },
      18: { // Webinar 18
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
        28: { url: '28.jpg', title: '28', type: 'picture' },
        29: { url: '29.jpg', title: '29', type: 'picture' },
        30: { url: '30.jpg', title: '30', type: 'picture' },
        31: { url: '31.jpg', title: '31', type: 'picture' },
        32: { url: '32.jpg', title: '32', type: 'picture' },
        33: { url: '33.jpg', title: '33', type: 'picture' },
        34: { url: '34.jpg', title: '34', type: 'picture' },
        35: { url: '35.jpg', title: '35', type: 'picture' },
        36: { url: '36.jpg', title: '36', type: 'picture' },
        37: { url: '37.jpg', title: '37', type: 'picture' },
        38: { url: '38.jpg', title: '38', type: 'picture' },
        39: { url: '39.jpg', title: '39', type: 'picture' },
        40: { url: '40.jpg', title: '40', type: 'picture' },
        41: { url: '41.jpg', title: '41', type: 'picture' },
        42: { url: '42.jpg', title: '42', type: 'picture' },
        43: { url: '43.jpg', title: '43', type: 'picture' },
        44: { url: '44.jpg', title: '44', type: 'picture' },
        45: { url: '45.jpg', title: '45', type: 'picture' },
        46: { url: '46.jpg', title: '46', type: 'picture' },
        47: { url: '47.jpg', title: '47', type: 'picture' },
        48: { url: '48.jpg', title: '48', type: 'picture' },
        49: { url: '49.jpg', title: '49', type: 'picture' },
        50: { url: '50.jpg', title: '50', type: 'picture' },
        51: { url: '51.jpg', title: '51', type: 'picture' },
        52: { url: '52.jpg', title: '52', type: 'picture' },
        53: { url: '53.jpg', title: '53', type: 'picture' },
        54: { url: '54.jpg', title: '54', type: 'picture' },
        55: { url: '55.jpg', title: '55', type: 'picture' },
      },
      16: { // Webinar 16
          1: { url: '1.jpg', title: '1', type: 'picture' },
          2: { url: '2.jpg', title: '2', type: 'picture' },
          3: { url: '3.jpg', title: '3', type: 'picture' },
          4: { url: '4.jpg', title: '4', type: 'picture' },
          5: { url: '5.jpg', title: '5', type: 'picture' },
          6: { url: '6.jpg', title: '6', type: 'picture' },
          7: { url: '7.jpg', title: '7', type: 'picture' },
          8: { url: '8.jpg', title: '8', type: 'picture' },
          9: { url: '9.jpg', title: '9', type: 'picture' },
          10: { url: '10.jpg', title: '10', type: 'picture' },
          11: { url: '11.jpg', title: '11', type: 'picture' },
          12: { url: '12.jpg', title: '12', type: 'picture' },
          13: { url: '13.jpg', title: '13', type: 'picture' },
  },
      15: { // Webinar 15
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
      },
      14: { // Webinar 14
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
      },
      13: { // Webinar 13
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
      },
      12: { // Webinar 12
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
      },
      11: { // Webinar 11
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
        28: { url: '28.jpg', title: '28', type: 'picture' },
        29: { url: '29.jpg', title: '29', type: 'picture' },
        30: { url: '30.jpg', title: '30', type: 'picture' },
        31: { url: '31.jpg', title: '31', type: 'picture' },
        32: { url: '32.jpg', title: '32', type: 'picture' },
        33: { url: '33.jpg', title: '33', type: 'picture' },
        34: { url: '34.jpg', title: '34', type: 'picture' },
        35: { url: '35.jpg', title: '35', type: 'picture' },
        36: { url: '36.jpg', title: '36', type: 'picture' },
        37: { url: '37.jpg', title: '37', type: 'picture' },
        38: { url: '38.jpg', title: '38', type: 'picture' },
      },
      10: { // Webinar 10
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
      },
      9: { // Webinar 9
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
        28: { url: '28.jpg', title: '28', type: 'picture' },
        29: { url: '29.jpg', title: '29', type: 'picture' },
        30: { url: '30.jpg', title: '30', type: 'picture' },
        31: { url: '31.jpg', title: '31', type: 'picture' },
        32: { url: '32.jpg', title: '32', type: 'picture' },
        33: { url: '33.jpg', title: '33', type: 'picture' },
        34: { url: '34.jpg', title: '34', type: 'picture' },
        35: { url: '35.jpg', title: '35', type: 'picture' },
        36: { url: '36.jpg', title: '36', type: 'picture' },
        37: { url: '37.jpg', title: '37', type: 'picture' },
        38: { url: '38.jpg', title: '38', type: 'picture' },
        39: { url: '39.jpg', title: '39', type: 'picture' },
        40: { url: '40.jpg', title: '40', type: 'picture' },
        41: { url: '41.jpg', title: '41', type: 'picture' },
        42: { url: '42.jpg', title: '42', type: 'picture' },
        43: { url: '43.jpg', title: '43', type: 'picture' },
        44: { url: '44.jpg', title: '44', type: 'picture' },
        45: { url: '45.jpg', title: '45', type: 'picture' },
        46: { url: '46.jpg', title: '46', type: 'picture' },
        47: { url: '47.jpg', title: '47', type: 'picture' },
      },
      8: { // Webinar 8
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
      },
      7: { // Webinar 7
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
      },
      6: { // Webinar 4
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
        25: { url: '25.jpg', title: '25', type: 'picture' },
        26: { url: '26.jpg', title: '26', type: 'picture' },
        27: { url: '27.jpg', title: '27', type: 'picture' },
        28: { url: '28.jpg', title: '28', type: 'picture' },
        29: { url: '29.jpg', title: '29', type: 'picture' },
        30: { url: '30.jpg', title: '30', type: 'picture' },
        31: { url: '31.jpg', title: '31', type: 'picture' },
        32: { url: '32.jpg', title: '32', type: 'picture' },
        33: { url: '33.jpg', title: '33', type: 'picture' },
        34: { url: '34.jpg', title: '34', type: 'picture' },
        35: { url: '35.jpg', title: '35', type: 'picture' },
        36: { url: '36.jpg', title: '36', type: 'picture' },
        37: { url: '37.jpg', title: '37', type: 'picture' },
        38: { url: '38.jpg', title: '38', type: 'picture' },
        39: { url: '39.jpg', title: '39', type: 'picture' },
        40: { url: '40.jpg', title: '40', type: 'picture' },
        41: { url: '41.jpg', title: '41', type: 'picture' },
        42: { url: '42.jpg', title: '42', type: 'picture' },
        43: { url: '43.jpg', title: '43', type: 'picture' },
        44: { url: '44.jpg', title: '44', type: 'picture' },
        45: { url: '45.jpg', title: '45', type: 'picture' },
        46: { url: '46.jpg', title: '46', type: 'picture' },
        47: { url: '47.jpg', title: '47', type: 'picture' },
        48: { url: '48.jpg', title: '48', type: 'picture' },
        49: { url: '49.jpg', title: '49', type: 'picture' },
        50: { url: '50.jpg', title: '50', type: 'picture' },
        51: { url: '51.jpg', title: '51', type: 'picture' },
        52: { url: '52.jpg', title: '52', type: 'picture' },
        53: { url: '53.jpg', title: '53', type: 'picture' },
        54: { url: '54.jpg', title: '54', type: 'picture' },
        55: { url: '55.jpg', title: '55', type: 'picture' },
        56: { url: '56.jpg', title: '56', type: 'picture' },
        57: { url: '57.jpg', title: '57', type: 'picture' },
        58: { url: '58.jpg', title: '58', type: 'picture' },
        59: { url: '59.jpg', title: '59', type: 'picture' },
        60: { url: '60.jpg', title: '60', type: 'picture' },
        61: { url: '61.jpg', title: '61', type: 'picture' },
        62: { url: '62.jpg', title: '62', type: 'picture' },
        63: { url: '63.jpg', title: '63', type: 'picture' },
        64: { url: '64.jpg', title: '64', type: 'picture' },
        65: { url: '65.jpg', title: '65', type: 'picture' },
        66: { url: '66.jpg', title: '66', type: 'picture' },
        67: { url: '67.jpg', title: '67', type: 'picture' },
        68: { url: '68.jpg', title: '68', type: 'picture' },
        69: { url: '69.jpg', title: '69', type: 'picture' },
        70: { url: '70.jpg', title: '70', type: 'picture' },
        71: { url: '71.jpg', title: '71', type: 'picture' },
        72: { url: '72.jpg', title: '72', type: 'picture' },
        73: { url: '73.jpg', title: '73', type: 'picture' },
        74: { url: '74.jpg', title: '74', type: 'picture' },
        75: { url: '75.jpg', title: '75', type: 'picture' },
        76: { url: '76.jpg', title: '76', type: 'picture' },
        77: { url: '77.jpg', title: '77', type: 'picture' },
        78: { url: '78.jpg', title: '78', type: 'picture' },
        79: { url: '79.jpg', title: '79', type: 'picture' },
        80: { url: '80.jpg', title: '80', type: 'picture' },
        81: { url: '81.jpg', title: '81', type: 'picture' },
        82: { url: '82.jpg', title: '82', type: 'picture' },
        83: { url: '83.jpg', title: '83', type: 'picture' },
      },
      5: { // Webinar 5
        1: { url: '1.jpg', title: '1', type: 'picture' },
        2: { url: '2.jpg', title: '2', type: 'picture' },
        3: { url: '3.jpg', title: '3', type: 'picture' },
        4: { url: '4.jpg', title: '4', type: 'picture' },
        5: { url: '5.jpg', title: '5', type: 'picture' },
        6: { url: '6.jpg', title: '6', type: 'picture' },
        7: { url: '7.jpg', title: '7', type: 'picture' },
        8: { url: '8.jpg', title: '8', type: 'picture' },
        9: { url: '9.jpg', title: '9', type: 'picture' },
        10: { url: '10.jpg', title: '10', type: 'picture' },
        11: { url: '11.jpg', title: '11', type: 'picture' },
        12: { url: '12.jpg', title: '12', type: 'picture' },
        13: { url: '13.jpg', title: '13', type: 'picture' },
        14: { url: '14.jpg', title: '14', type: 'picture' },
        15: { url: '15.jpg', title: '15', type: 'picture' },
        16: { url: '16.jpg', title: '16', type: 'picture' },
        17: { url: '17.jpg', title: '17', type: 'picture' },
        18: { url: '18.jpg', title: '18', type: 'picture' },
        19: { url: '19.jpg', title: '19', type: 'picture' },
        20: { url: '20.jpg', title: '20', type: 'picture' },
        21: { url: '21.jpg', title: '21', type: 'picture' },
        22: { url: '22.jpg', title: '22', type: 'picture' },
        23: { url: '23.jpg', title: '23', type: 'picture' },
        24: { url: '24.jpg', title: '24', type: 'picture' },
      },
      
      4: { // Webinar 4
        1: { url: '1.jpg', title: '1', type: 'picture' },
     2: { url: '2.jpg', title: '2', type: 'picture' },
      //2: { url: 'https://customer-jaoojtcfa3gf91am.cloudflarestream.com/59b38533c7edab371933d75362d750a6/downloads/default.mp4', title: '39', type: 'video' },
      3: { url: '3.jpg', title: '3', type: 'picture' },
      4: { url: '4.jpg', title: '4', type: 'picture' },
      5: { url: '5.jpg', title: '5', type: 'picture' },
      6: { url: '6.jpg', title: '6', type: 'picture' },
      7: { url: '8.jpg', title: '7', type: 'picture' },
      8: { url: '9.jpg', title: '8', type: 'picture' },
      9: { url: '10.jpg', title: '9', type: 'picture' },
      10: { url: '11.jpg', title: '10', type: 'picture' },
      11: { url: '12.jpg', title: '11', type: 'picture' },
      12: { url: '13.jpg', title: '12', type: 'picture' },
      13: { url: '14.jpg', title: '13', type: 'picture' },
      14: { url: '15.jpg', title: '14', type: 'picture' },
      15: { url: '16.jpg', title: '15', type: 'picture' },
      16: { url: '19.jpg', title: '16', type: 'picture' },
      17: { url: '20.jpg', title: '17', type: 'picture' },
      18: { url: '21.jpg', title: '18', type: 'picture' },
      19: { url: '22.jpg', title: '19', type: 'picture' },
      20: { url: '23.jpg', title: '20', type: 'picture' },
      21: { url: '24.jpg', title: '21', type: 'picture' },
      22: { url: '25.jpg', title: '22', type: 'picture' },
      23: { url: '29.jpg', title: '23', type: 'picture' },
      24: { url: '31.jpg', title: '24', type: 'picture' },
      25: { url: '32.jpg', title: '25', type: 'picture' },
      26: { url: '36.jpg', title: '26', type: 'picture' },
      27: { url: '37.jpg', title: '27', type: 'picture' },
      28: { url: '38.jpg', title: '28', type: 'picture' },
      29: { url: '44.jpg', title: '29', type: 'picture' },
      30: { url: '45.jpg', title: '30', type: 'picture' },
      31: { url: '46.jpg', title: '31', type: 'picture' },
      32: { url: '47.jpg', title: '32', type: 'picture' },
      33: { url: '48.jpg', title: '33', type: 'picture' },
      34: { url: '53.jpg', title: '34', type: 'picture' },
      35: { url: '54.jpg', title: '35', type: 'picture' },
      36: { url: '55.jpg', title: '36', type: 'picture' },
      37: { url: '56.jpg', title: '37', type: 'picture' },
      38: { url: '57.jpg', title: '38', type: 'picture' },
      39: { url: 'https://customer-jaoojtcfa3gf91am.cloudflarestream.com/59b38533c7edab371933d75362d750a6/downloads/default.mp4', title: '39', type: 'video' },
      40: { url: '60.jpg', title: '40', type: 'picture' },
      41: { url: '61.jpg', title: '41', type: 'picture' },
      42: { url: '62.jpg', title: '42', type: 'picture' },
      43: { url: '63.jpg', title: '43', type: 'picture' },
      44: { url: '64.jpg', title: '44', type: 'picture' },
      45: { url: '65.jpg', title: '45', type: 'picture' },
      46: { url: '66.jpg', title: '46', type: 'picture' },
      47: { url: '67.jpg', title: '47', type: 'picture' },
      48: { url: '68.jpg', title: '48', type: 'picture' },
      49: { url: '74.jpg', title: '49', type: 'picture' },
      50: { url: '75.jpg', title: '50', type: 'picture' },
      51: { url: '76.jpg', title: '51', type: 'picture' },
      52: { url: '77.jpg', title: '52', type: 'picture' },
      53: { url: '78.jpg', title: '53', type: 'picture' },
      54: { url: '79.jpg', title: '54', type: 'picture' }
      }
    }
  }),
  actions: {
    updatePictureBroadcast(data) {
      this.pictureBroadCast = data;
    }
  }
});
